import evalCondition from 'Helpers/evalCondition'
import { notifyParent } from 'Helpers/notifyParent'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import {
  Button,
  BUTTON_SIZE_LG,
  BUTTON_VARIANT_PRIMARY,
  PageHeader
} from 'mailup-web-components'
import { pageState } from 'Pages/DynamicContentList/recoil/state/page'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router'
import { useRecoilValue } from 'recoil'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const [redirectUrl] = useRedirectorUrl()

  const { isEmptyState } = useRecoilValue(pageState)
  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Automation' }),
      'data-mu-test': 'breadcrumb-item__automation',
      className: 'test-breadcrumb-item__automation'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Content' }),
      'data-mu-test': 'breadcrumb-item__content',
      className: 'test-breadcrumb-item__content',
      url: '#',
      onClick: () => history.push('/automation/sources/list')
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.DynamicContent' }),
      'data-mu-test': 'breadcrumb-item__automation-dynamiccontentlist',
      className: 'test-breadcrumb-item__automation-dynamiccontentlist'
    }
  ]

  const menuItems = [
    ...(evalCondition(
      'uo:NL AND uo:ENHTRIGGEREDUSE AND co:ENHTRIGGEREDUSE AND uo:CONTENTSSOURCES'
    )
      ? [
          {
            label: intl.formatMessage({ id: 'Load.NavMenu.ContentsSources' }),
            'data-mu-test': 'topmenu-item__contentsSources',
            className: 'test-topmenu-item__contentsSources',
            onClick: () => history.push('/automation/sources/list')
          }
        ]
      : []),
    ...(evalCondition('uo:NL AND uo:ENHTRIGGEREDUSE AND co:ENHTRIGGEREDUSE')
      ? [
          {
            label: intl.formatMessage({
              id: 'Load.NavMenu.ContentsCampaignList'
            }),
            onClick: () => history.push('/automation/contentsCampaign/list'),
            'data-mu-test': 'topmenu-item__contentsCampaignList',
            className: 'test-topmenu-item__contentsCampaignList'
          }
        ]
      : []),
    ...(evalCondition('uo:DYNFLD')
      ? [
          {
            label: intl.formatMessage({ id: 'Load.NavMenu.DynamicContent' }),
            onClick: () => null,
            'data-mu-test': 'topmenu-item__dynamiccontentlist',
            className: 'test-topmenu-item__dynamiccontentlist',
            isActive: true
          }
        ]
      : [])
  ]

  useEffect(() => {
    notifyParent('selectMenuItemReact', ['DynamicContent', redirectUrl])
  }, [redirectUrl])

  const ControlsComponent = () => {
    const handleClick = () => {
      notifyParent('redirectMainFrame', [
        '/console/GestoreContenutiEsterni.aspx'
      ])
    }

    return isEmptyState ? null : (
      <Button
        kind={BUTTON_VARIANT_PRIMARY}
        size={BUTTON_SIZE_LG}
        onClick={handleClick}
        data-mu-test='header-button'
      >
        {intl.formatMessage({ id: 'Load.DynamicContentList.AddNew' })}
      </Button>
    )
  }
  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      menuItems={menuItems}
      ControlsComponent={ControlsComponent}
      title={intl.formatMessage({
        id: 'Load.NavMenu.DynamicContent'
      })}
    />
  )
}

export default Header
